//
// Copyright (c) 2024 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
// @ts-ignore
import Messenger from "messaging/messenger";
// @ts-ignore
import Backbone from "backbone";

export default class MessengerAdapter extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "MessengerAdapter";
  }

  reqres(): Backbone.Wreqr.RequestResponse {
    return Messenger.reqres;
  }

  vent(): Backbone.Wreqr.EventAggregator {
    return Messenger.vent;
  }
}
